import React, { useState } from 'react'
import { BiRightArrowAlt } from 'react-icons/bi'
import { MdError } from "react-icons/md"
import { InvoiceIcon, SettingIcon } from '../../Assets/AllSvg'
import { BsArrowRightShort, BsThreeDots } from 'react-icons/bs'
import DeleteDraftModal from '../DeleteDraftModal/DeleteDraftModal'
import { Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react'
import { CreateNewInvoice, GetInovices } from '../API/InvoiceAPI'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify'
import DownloadInvoice from '../DownloadInvoice/DownloadInvoice'

const menu = [
    { name: "All invoices", value: "All" },
    { name: "Draft", value: "Draft" },
    { name: "Outstanding", value: "Outstanding" },
    { name: "Past due", value: "PastDue" },
    { name: "Paid", value: "Paid" },
]

const BillInvoice = () => {
    const [data, setData] = useState('All')
    const [delDraft, setDelDraft] = useState(false)
    const [invoiceList, setInvoiceList] = useState([])
    const [deleteInvoiceData, setDeleteInvoiceData] = useState('')
    const [draftDel, setDraftDel] = useState(false)
    const [downloadDraft, setDownloadDraft] = useState(false)
    const [downloadInvoiceData, setDownloadInvoiceData] = useState('')

    const navigate = useNavigate()

    const navigateToEdit = (id) => {
        navigate(`/billing/create?id:${id}`)
    }

    const getInvoices = async () => {
        const result = await GetInovices()
        const userID = localStorage.getItem("user")
        const fltData = result && result.filter((val) => val.user_id === userID)

        if (data === "All") {
            setInvoiceList(fltData)
        } else {
            const filterData = fltData.filter((val) => val.status === data)
            setInvoiceList(filterData)
        }
    }

    const handleClickDuplicate = async (invoice) => {
        const postParams = {
            createInvoice_ItemsInput: {
                ...invoice,
                invoice_items_id: uuidv4(),
                inserted_dt: new Date().toISOString()
            },
        };

        const result = await CreateNewInvoice(postParams)
        if (result) {
            navigate(`/billing/create?id:${result.invoice_items_id}`)
            toast.success("Duplicate Invoice created successfully", { autoClose: 5000 });
        } else {
            toast.error("Something went wrong", { autoClose: 5000 });
        }
    }

    useEffect(() => {
        getInvoices()
    }, [draftDel, data])

    return (
        <>
            <div>
                <div className="my-[16px] gap-2 sm:flex-row flex-col sm:p-[16px_20px] p-[16px] bg-[#fef9da] border-[1px] border-[rgb(235,238,241)] rounded-md flex justify-between sm:items-center items-start">
                    <div className="flex gap-2">
                        <MdError className='text-[#ed6704] mt-[2px] text-[15px]' />
                        <div className='text-sm'>
                            <span className='text-[#1a1b25] font-semibold'>Finish setting up invoices</span>
                            <p className='text-[#414552]'>Activate payments to start charging customers with invoices.</p>
                        </div>
                    </div>
                    <button onClick={() => navigate('/active-payment')} className="input_focus_shadow w-max whitespace-nowrap h-[30px] flex items-center rounded-[6px] bg-white text-[14px] font-semibold p-[0_8px]">Activate payments</button>
                </div>
                <div className="my-[16px]">
                    <div className='w-full overflow-x-auto'>
                        <div className="grid grid-cols-5 gap-2 text-sm sm:w-full w-[610px] overflow-x-auto">
                            {menu.map((val, i) => {
                                return (
                                    <button className={`${data === val.value ? "font-semibold text-[#625afa] border-[#625afa] border-[2px]" : "border-[#d5dbe1] font-normal text-[#414552] border-[1px]"} p-[11px] rounded-[8px] text-start`} onClick={() => setData(val.value)} key={i}>{val.name}</button>
                                )
                            })}
                        </div>
                    </div>
                    {invoiceList.length !== 0 &&
                        <div className='mt-5'>
                            <div className='w-full overflow-x-auto'>
                                <table className='md:w-full w-[800px] table-auto overflow-x-auto invoice-table'>
                                    <thead className='border-b-[1px] border-[#ebeef1]'>
                                        <tr>
                                            <th>AMOUNT</th>
                                            <th></th>
                                            <th></th>
                                            <th>INVOICE NUMBER</th>
                                            <th>
                                                <button className='flex gap-1 items-center'>LINE ITEMS <SettingIcon className="fill-gray-600 h-[12px] w-[12px]" /></button>
                                            </th>
                                            <th>DUE</th>
                                            <th>CREATED</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    {invoiceList.map((val) =>
                                        <tbody key={val.invoice_items_id}>
                                            <tr className='border-b-[1px] border-[#ebeef1] group'>
                                                <td onClick={() => navigateToEdit(val.invoice_items_id)}>$ {val.price * val.qty}</td>
                                                <td onClick={() => navigateToEdit(val.invoice_items_id)}>USD</td>
                                                <td onClick={() => navigateToEdit(val.invoice_items_id)}>
                                                    <div className='p-[1px_6px] text-[12px] w-max rounded-[4px] bg-[#ebeef1]'>{val.status}</div>
                                                </td>
                                                <td onClick={() => navigateToEdit(val.invoice_items_id)}>{val.invoice_items_id}</td>
                                                <td onClick={() => navigateToEdit(val.invoice_items_id)}>{val.item}</td>
                                                <td onClick={() => navigateToEdit(val.invoice_items_id)}>{val.supply_date}</td>
                                                <td onClick={() => navigateToEdit(val.invoice_items_id)}>{moment(val.inserted_dt).format("MMMM DD, h:mm a")}</td>
                                                <td>
                                                    <Menu placement='bottom-end'>
                                                        <MenuHandler>
                                                            <button className='group-hover:bg-white p-[4px_8px] rounded-r-md group-hover:input_focus_shadow'><BsThreeDots /></button>
                                                        </MenuHandler>
                                                        <MenuList className='max-w-[168px] py-[8px] outline-remove font-medium shadow-lg px-0 w-full'>
                                                            <div className='text-[#687385] px-3 py-[5px] text-[12px]'>ACTIONS</div>
                                                            <MenuItem onClick={() => { setDownloadDraft(true); setDownloadInvoiceData(val) }} className='rounded-none w-full px-3 outline-none hover:text-[#625afa] text-[#625afa] hover:bg-[#f7f7f7] py-[4px]'>Download PDF</MenuItem>
                                                            <div onClick={() => navigateToEdit(val.invoice_items_id)} className='text-[#8791a1] px-3 py-[5px] text-[14px]'>Edit invoice</div>
                                                            <MenuItem onClick={() => handleClickDuplicate(val)} className='rounded-none w-full px-3 outline-none hover:text-[#625afa] text-[#625afa] hover:bg-[#f7f7f7] py-[5px]'>
                                                                Duplicate invoice
                                                            </MenuItem>
                                                            <MenuItem className='rounded-none w-full px-3 outline-none hover:text-[#e01515] text-[#e01515] hover:bg-[#f7f7f7] py-[5px]' onClick={() => { setDelDraft(true); setDeleteInvoiceData(val) }}>Delete draft</MenuItem>
                                                            <hr className='my-2' />
                                                            <div className='text-[#687385] px-3 py-[5px] text-[12px]'>CONNECTIONS</div>
                                                            <MenuItem className='rounded-none w-full px-3 outline-none flex gap-1 items-center hover:text-[#625afa] text-[#625afa] hover:bg-[#f7f7f7] py-[5px]' onClick={() => navigate(`/customers/${val.customer_id}`)}>View customer <BsArrowRightShort className="text-[22px]" /></MenuItem>
                                                        </MenuList>
                                                    </Menu>
                                                </td>
                                            </tr>
                                        </tbody>
                                    )}

                                </table>
                            </div>
                            <div className="flex justify-between items-center mt-2">
                                <span className="text-[#687385] text-sm"><b>{invoiceList.length}</b> results</span>
                                <div className="flex gap-2">
                                    <button className="input_focus_shadow h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60" disabled="">Previous</button>
                                    <button className="input_focus_shadow h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60" disabled>Next</button>
                                </div>
                            </div>
                        </div>
                    }
                    {invoiceList.length === 0 &&
                        <>
                            <div className='md:h-[564px] h-fit flex items-center justify-center'>
                                <div className="md:p-[64px] p-[50px_0]">
                                    <div className='p-[12px] w-max rounded-[8px] bg-[#f6f8fa]'>
                                        <InvoiceIcon className="fill-gray-600 w-[24px] h-[24px]" />
                                    </div>
                                    <div className="mt-6">
                                        <span className="text-[20px] font-bold text-[#1a1b25]">
                                            {data === "Outstanding" && "No paid test invoices"}
                                            {data === "PastDue" && "No test invoices are past due"}
                                            {data === "Paid" && "No paid test invoices"}
                                        </span>
                                    </div>
                                    <p className="text-sm text-[#687385] max-w-[389px] flex-wrap mt-1">
                                        {data === "Outstanding" && "Test invoices that haven’t been paid yet will show up here."}
                                        {data === "PastDue" && "Test invoices that haven’t been paid by their due date will show up here."}
                                        {data === "Paid" && "Test invoices that are paid will show up here."}
                                    </p>
                                    <button className="text-[#625afa] mt-1 flex items-center font-medium gap-1">Learn more
                                        <BiRightArrowAlt className='text-[20px] translate-y-[2px]' />
                                    </button>
                                </div>
                            </div>
                            <div className="flex justify-between items-center pt-2 border-t-[1px] border-[#ebeef1]">
                                <span className="text-[#687385] text-sm"><b>0</b> results</span>
                                <div className="flex gap-2">
                                    <button className="border-[2px] h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60" disabled="">Previous</button>
                                    <button className="border-[2px] h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60" disabled>Next</button>
                                </div>
                            </div>
                        </>
                    }
                </div>
                <div className="mt-14 mb-40">
                    <span className='text-[18px] text-[#414552] font-semibold'>Learn more about invoicing</span>
                    <div className="grid md:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-3 mt-4">
                        <div className='sm:p-[24px] p-[16px] text-sm text-[#414552] border-[1px] border-[#d5dbe1] rounded-lg'>
                            <h2 className='font-semibold mb-2'>Customize your brand</h2>
                            <p>Add your company logo and colors to your PDF, email, and payment page.</p>
                            <button className='mt-10 text-[#625afa] flex items-center font-semibold'>Brand<BiRightArrowAlt className="text-[20px]" /></button>
                        </div>
                        <div className='sm:p-[24px] p-[16px] text-sm text-[#414552] border-[1px] border-[#d5dbe1] rounded-lg'>
                            <h2 className='font-semibold mb-2'>Configure invoices</h2>
                            <p>Add payment methods, tax IDs, or configure advanced features.</p>
                            <button className='mt-10 text-[#625afa] flex items-center font-semibold'>Invoice template<BiRightArrowAlt className="text-[20px]" /></button>
                        </div>
                        <div className='sm:p-[24px] p-[16px] text-sm text-[#414552] border-[1px] border-[#d5dbe1] rounded-lg'>
                            <h2 className='font-semibold mb-2'>Upgrade to Invoicing Plus</h2>
                            <p>Boost your revenue with advanced features like Smart Retries and automatic payment reminders.</p>
                            <button className='mt-10 text-[#625afa] flex items-center font-semibold'>Billing plans<BiRightArrowAlt className="text-[20px]" /></button>
                        </div>
                    </div>
                </div>
            </div>
            <DeleteDraftModal delDraft={delDraft} setDelDraft={setDelDraft} deleteInvoiceData={deleteInvoiceData} setDeleteInvoiceData={setDeleteInvoiceData} draftDel={draftDel} setDraftDel={setDraftDel} />
            <DownloadInvoice downloadDraft={downloadDraft} setDownloadDraft={setDownloadDraft} downloadInvoiceData={downloadInvoiceData} setDownloadInvoiceData={setDownloadInvoiceData} />
        </>
    )
}

export default BillInvoice